export interface TestChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

export interface TestChatRequest {
  agentId: string;
  message: string;
  chatHistory: TestChatMessage[];
}

export interface TestChatResponse {
  response: string;
  updatedChatHistory: TestChatMessage[];
  warning: string;
}

export interface AgentTestInfo {
  agentId: string;
  agentName: string;
  hasBrain: boolean;
  promptsCount: number;
  model: string;
  useMostPowerfulModel: boolean;
  canTest: boolean;
  warning: string;
}

const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

class TestChatApiService {
  private getAuthHeaders() {
    const token = localStorage.getItem('authToken');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async sendMessage(request: TestChatRequest): Promise<TestChatResponse> {
    const response = await fetch(`${API_BASE_URL}/TestChat/SendMessage`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Failed to send test chat message');
    }

    return await response.json();
  }

  async clearChatHistory(agentId: string): Promise<{ message: string }> {
    const response = await fetch(`${API_BASE_URL}/TestChat/ClearChatHistory/${agentId}`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to clear chat history');
    }

    return await response.json();
  }

  async getAgentTestInfo(agentId: string): Promise<AgentTestInfo> {
    const response = await fetch(`${API_BASE_URL}/TestChat/GetAgentTestInfo/${agentId}`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to get agent test info');
    }

    return await response.json();
  }
}

export const testChatApi = new TestChatApiService();
